import { createAction, props } from '@ngrx/store';

import { CalendarConfiguration } from '../../_models';

/** init */
export const initFeature = createAction(
  '[Calendar Configuration] Init Calendar Configuration Feature'
);
export const featureInitSuccess = createAction(
  '[Calendar Configuration] Feature Initialized',
  props<{ calendarConfiguration: CalendarConfiguration }>()
);
export const featureInitError = createAction('[Calendar Configuration] Feature Init Error');

/** state */
export const clearState = createAction('[Notes Manager] Clear State');

/** dialog */
export const confirmChanges = createAction('[Calendar Configuration] Confirm Changes');

export const cancelChanges = createAction('[Calendar Configuration] Cancel Changes');

export const openCalendarConfigurationDialog = createAction(
  '[Calendar Configuration] Open Calendar Configuration Dialog'
);
